import styled from '@emotion/styled'
import TimeAgo from '~/components/TimeAgo'
import { Avatar, H4, color, shadow, space, fontSize, radius } from '@ticketswap/solar'

const Container = styled.div`
  width: 100%;
  box-shadow: ${shadow.strong};
  padding-block: ${space[24]};
  padding-inline: ${space[24]};
  border-radius: ${radius.lg};
  background-color: ${color.background};

  [data-theme='dark'] & {
    border: 1px solid ${color.stroke};
  }
`

const Time = styled.time`
  font-size: ${fontSize[14]};
  display: block;
  color: ${color.foregroundSubtle};
`

const Message = styled.p`
  margin-block: 0;
  margin-inline: 0;
  white-space: normal;
`

const ItemHeader = styled.header`
  display: inline-flex;
  align-items: center;
  margin-block-end: ${space[16]};
`

const AvatarContainer = styled.div`
  margin-inline-end: ${space[16]};
`

const TestimonialCard = ({ user, createdAt, description }) => {
  return (
    <Container>
      <ItemHeader>
        <AvatarContainer>
          <Avatar size={48} src={user.avatar} />
        </AvatarContainer>
        <div>
          <H4>{user.firstname}</H4>
          <Time>
            <TimeAgo date={createdAt} />
          </Time>
        </div>
      </ItemHeader>
      <Message>{description}</Message>
    </Container>
  )
}

export default TestimonialCard
